export const configCollectionGuard = 'GET /configs';
export const editConfigResourceGuard = 'PUT /configs/d+';
